import ReactGA from "react-ga4";

export const initializeAnalytics = () => {
  ReactGA.initialize("G-GK3KGFRMJD");
};

export const trackPageView = (path: string) => {
  ReactGA.send({ hitType: "pageview", page: path });
};